export default __webpack_public_path__ + "a3a62c646fcb42c744451313861961d3.png";